import React, { useEffect } from 'react';

const AboutMeetSection = () => {
  // Initialize PureCounter when component mounts
  useEffect(() => {
    if (typeof window !== 'undefined' && window.PureCounter) {
      new window.PureCounter();
    }
  }, []);

  return (
    <section className="about about--style1 bg-color">
      <div className="container">
        <div className="about__wrapper">
            <h2 className="meet-oppurtanity text-center mb-4">
              A Legacy of Trust. <span className="style2">A Future of Innovation.</span>
            </h2>

            <p>
              Asiatic Stock & Securities Ltd. has been a trusted name in India’s capital markets for over three decades. Established as a proud member of the National Stock Exchange (NSE) since 1995 and the Bombay Stock Exchange (BSE), we are SEBI-registered brokers offering comprehensive access across Cash and Futures on both BSE and NSE.
            </p>

          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            {/* Image Section */}
            <div className="col-lg-6">
              <div
                className="about__thumb "
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img
                      className="dark"
                      src="assets/images/new/abbout.jpg"
                      alt="About Asiatic Stock & Securities Ltd."
                    />
                    {/* Optional floating counters */}
                  </div>
                </div>
              </div>
            </div>

            {/* Content Section */}
            <div className="col-lg-6">
              <div
                className="about__content"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="about__content-inner text-justify">
                 

                  <h2 className='text-center'>Our Belief</h2>
                  <p>
                    At Asiatic, we believe true trading talent is discovered, not hired.
                    Most people enter the markets chasing quick profits. But the ones who endure the ones who truly belong are those who survive the losses, learn from the chaos, and keep coming back sharper and humbler.
                    Trading is a solitary pursuit. It forces you to confront your own biases, challenge every belief, and think differently from the crowd.
                  </p>
                  <p>At Asiatic, we’ve built an environment that identifies and nurtures such individuals those whose passion and life revolve around trading. We provide the structure, the discipline, and the support that allows them to evolve into independent, resilient market participants.
                    We don’t just tolerate differences in thought we celebrate them. Because it is at those intersections of conviction and contradiction that great trading minds are born.
                  </p>

                 
                </div>
              </div>
            </div>
          </div>

            {/* Founders Section */}
            <h2 className="my-4 text-center">Our Founders</h2>
            <div className="row gx-4 gy-4">
              {/* Founder 1 */}
              <div className="col-md-6 d-flex align-items-start">
                <img
                  src="assets/images/icon/avatar.webp"
                  alt="Mr. H.K. Gupta"
                  className="founder-image me-3"
                  style={{ width: '150px', borderRadius: '20px' }}
                />
                <div className='text-justify'>
                  <p>
                    <strong>Mr. H.K. Gupta</strong> (B.Sc. Mechanical Engineering, MBA) — a visionary investor and market analyst with deep expertise in both technical and fundamental analysis since 1985. Under his leadership, Asiatic Stock & Securities Ltd. has evolved from a traditional brokerage into a modern, technology-driven financial house, trusted by investors and traders nationwide.
                  </p>
                </div>
              </div>

              {/* Founder 2 */}
              <div className="col-md-6 d-flex align-items-start">
                <img
                  src="assets/images/icon/avatar.webp"
                  alt="Mr. Abhinav Gupta"
                  className="founder-image me-3"
                  style={{ width: '150px', borderRadius: '20px' }}
                />
                <div className='text-justify'>
                  <p>
                    <strong>Mr. Abhinav Gupta</strong> (B.A. Economics, MBA), who brings over 15 years of experience in derivatives and quantitative trading. His analytical rigor, combined with a deep understanding of algorithmic strategy design and risk management, drives the firm’s innovation in automated and data-led trading solutions.
                  </p>
                </div>
              </div>
            </div>

            <h2 className="my-4 text-center">Our Commitment</h2>
            <div>            
              <p>
                For over three decades, Asiatic Stock & Securities Ltd. has maintained a complaint-free and litigation-free record — a rare distinction that reflects our unwavering dedication to integrity, transparency, and client-first service.
              </p>
              <p>
                Whether you are a long-term investor, a quantitative trader, or a short-term market participant, we provide the expertise, tools, and personalized support to help you grow, adapt, and succeed in today’s dynamic markets.
              </p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMeetSection;
